var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            "justify-content": "space-between",
            "align-items": "center",
          },
        },
        [
          _c(
            "span",
            { staticStyle: { "font-size": "18px", "font-weight": "bold" } },
            [_vm._v("意見調查滿意度（整團平均分數）")]
          ),
          _c(
            "router-link",
            { attrs: { to: "/agency/agencyOpinionSurvey/index" } },
            [
              _c("el-button", {
                attrs: {
                  size: "mini",
                  icon: "el-icon-arrow-right",
                  circle: "",
                  text: "",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        {
          staticClass: "box-card-component",
          staticStyle: { "margin-top": "8px" },
        },
        [
          _c(
            "div",
            { staticStyle: { position: "relative", height: "272px" } },
            [
              _vm.statisticsData && _vm.statisticsData.length > 0
                ? _c(
                    "div",
                    { staticStyle: { height: "100%", overflow: "auto" } },
                    _vm._l(_vm.statisticsData, function (item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "progress-item" },
                        [
                          _c(
                            "div",
                            [
                              _c("span", [_vm._v(_vm._s(item.travelName))]),
                              _c("el-progress", {
                                attrs: {
                                  percentage: item.analysis,
                                  color: _vm.customColorMethod,
                                  format: _vm.formatValue,
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e(),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }